export default "__VITE_ASSET__96bf5878__"